/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Kinds_DescInputs */



/**
* | output |
* | --- |
* | "Wundo finds these on your calendar itself, including meetings booked later." |
*
* @param {Meetings_Kinds_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_kinds_desc = /** @type {((inputs?: Meetings_Kinds_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Kinds_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo vindt die zelf in je agenda, ook gesprekken die je later inplant.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo les trouve lui-même dans votre agenda, y compris les conversations que vous planifiez plus tard.")
	return /** @type {LocalizedString} */ ("Wundo finds these on your calendar itself, including meetings booked later.")
});